var map = {
	"./Blue/0.png": 80656,
	"./Blue/1.png": 90440,
	"./Blue/2.png": 82756,
	"./Blue/3.png": 52673,
	"./Blue/4.png": 36351,
	"./Gray/0.png": 29751,
	"./Gray/1.png": 66300,
	"./Gray/2.png": 12809,
	"./Gray/3.png": 75441,
	"./Gray/4.png": 90341,
	"./Green/0.png": 80161,
	"./Green/1.png": 51224,
	"./Green/2.png": 47673,
	"./Green/3.png": 31457,
	"./Green/4.png": 64213
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49219;